import { LucideIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { QuoteListRow } from 'src/api/db/apiQuote'
import { paths } from 'src/routes/paths'
import { Row } from 'src/shared/components/Semantic/all'
import { Card } from 'src/shared/components/ui/card'
import { cn } from 'src/shared/components/ui/utils'
import {
  DASHBOARD_CARD_VARIANTS,
  type DashboardCardVariant,
} from '../consts'
import { DashboardOrderRow } from './DashboardOrderRow'
import { FadedOrderList } from './FadedOrderList'

export const DashboardOrderListCard = ({
  title,
  description,
  icon: Icon,
  orders,
  listSearch = '',
  viewAllSearch = '',
  variant,
  emptyMessage,
}: {
  title: string
  description: string
  icon: LucideIcon
  orders: QuoteListRow[]
  listSearch?: string
  viewAllSearch?: string
  variant: DashboardCardVariant
  emptyMessage: string
}) => {
  const navigate = useNavigate()
  const styles = DASHBOARD_CARD_VARIANTS[variant]

  const viewAllHref =
    `${paths.myAccount}${paths.requests}` +
    (viewAllSearch.startsWith('?')
      ? viewAllSearch
      : viewAllSearch
        ? `?${viewAllSearch}`
        : '')

  return (
    <Card
      wrapperClassName="min-w-0 flex-1"
      className={cn('min-w-0 gap-3 p-4', styles.card)}
    >
      <button
        type="button"
        onClick={() => navigate(viewAllHref)}
        className="text-left transition-opacity hover:opacity-80"
      >
        <Row className="items-center gap-2">
          <Icon
            className={cn('h-4 w-4 shrink-0', styles.icon)}
            strokeWidth={2}
          />
          <h3>{title}</h3>
        </Row>
        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      </button>

      {orders.length === 0 ? (
        <p className="text-sm text-muted-foreground">{emptyMessage}</p>
      ) : (
        <FadedOrderList
          fadeClassName={styles.fade}
          showFade={orders.length > 1}
        >
          {orders.map((quote, index) => (
            <DashboardOrderRow
              key={String(quote.public_id ?? quote.id ?? index)}
              quote={quote}
              listSearch={listSearch}
            />
          ))}
        </FadedOrderList>
      )}
    </Card>
  )
}
